<template>
  <TextField :label="$tt('year')" persistent-hint />
</template>